<script setup lang="ts">
import { NodeViewContent, nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3";
import { createSocialsBlock } from "~/stores/mail-block-editor/defaults";
import { MailMjmlColumn, MailMjmlSection } from "#components";

const store = useMailStore();
const props = defineProps(nodeViewProps);

const theme = computed(() => {
    const theme = store.fieldCollection.replaceContent(
        createSocialsBlock(props.node.attrs),
    );

    return theme;
});
</script>

<template>
    <NodeViewWrapper
        class="socials"
        @click.stop="store.focusedJsonId = node.attrs.id"
        :style="{ '--mj-icon-size': theme.iconSize, '--mj-font-size': theme.fontSize }"
        :class="{ 
            vertical: theme.mode === 'vertical',
            'center': theme.alignment === 'center',
            'end': theme.alignment === 'right',
            'start': theme.alignment === 'left',
        }"
        :as="MailMjmlColumn"
        width="100%"
        :padding-top="theme.marginTop"
        :padding-bottom="theme.marginBottom"
    >
        <NodeViewContent />
    </NodeViewWrapper>
</template>

<style scoped>
.socials [data-node-view-content] {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.socials.vertical [data-node-view-content] {
    flex-direction: column;
}

.socials.center [data-node-view-content] {
    justify-content: center;
}

.socials.end [data-node-view-content] {
    justify-content: flex-end;
}

.socials.start [data-node-view-content] {
    justify-content: flex-start;
}
</style>
